export function normalizeInquiryTerms(value) {
  return String(value || "")
    .replace(/das Lead\s*Center/gi, "den Bereich Anfragen")
    .replace(/im Lead\s*Center/gi, "im Bereich Anfragen")
    .replace(/Lead\s*Center/gi, "Anfragen")
    .replace(/Neuer Lead/g, "Neue Anfrage")
    .replace(/Neue Leads/g, "Neue Anfragen");
}

export function notificationText(value) {
  return normalizeInquiryTerms(value).replace(/heyflow/gi, "Anfrageformular");
}
